import React from "react";
import {
    Col,
    Container,
} from "reactstrap";



const RequestBuild = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <p>en cours</p>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RequestBuild;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license